// Copyright ©️ 2026 eVolve MEP, LLC

import type { AutodeskExternalId } from '@evolvemep/api-ts';

export type SelectionMouseEvent = MouseEvent & { canvasX: number; canvasY: number };

export const SINGLE_SELECT_TOOL_NAME = 'single-select-tool';
export const MULTI_SELECT_TOOL_NAME = 'multi-select-tool';
export const WINDOW_SELECT_TOOL_NAME = 'window-select-tool';

export const SELECTION_TOOLS = [SINGLE_SELECT_TOOL_NAME, MULTI_SELECT_TOOL_NAME, WINDOW_SELECT_TOOL_NAME] as const;
export type SelectionTool = (typeof SELECTION_TOOLS)[number];

type Hotkey = {
  keycodes: Autodesk.Viewing.KeyCode[];
  onPress: () => boolean;
  onRelease: () => boolean;
};

/**
 * HotkeyManager type from Autodesk Viewer API, and should eventually live under Autodesk.Viewing.HotkeyManager
 * viewer.getHotkeyManager() is currently types as 'any' in the official type definitions, so we define it here for now.
 *
 * @see https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/forge-viewer
 * @see https://aps.autodesk.com/en/docs/viewer/v7/reference/Viewing/HotkeyManager/
 */
export type HotkeyManager = {
  pushHotkeys: (id: string, hotkeys: Hotkey[], options?: { tryUntilSuccess: boolean }) => boolean;
};

export type ForgeViewerSelection = { dbId: number; externalId: AutodeskExternalId };
